import { useEffect, useState } from 'react'
import type { TrainingMatrixFilters } from '../API/rtk-query-api/store/tmsApi'
import { useAppSelector } from '../redux/hooks'

const useFormattedFilters = () => {
  const [currentFilters, setCurrentFilters] = useState<TrainingMatrixFilters>({
    competencies: [],
    hierarchies: [],
    ignoreHierarchyFilterOccupationRequirements: false,
    managerIds: [],
    matchOption: 'MATCH_ANY',
    occupations: [],
    people: [],
    showAllCompetencies: false,
    showAllReports: false,
    applyHierarchyFiltersToOccupationRequirements: false
  })

  const trainingMatrixFilters = useAppSelector(state => state.trainingMatrixFilters)

  useEffect(() => {
    setCurrentFilters({
      competencies: trainingMatrixFilters.selectedCompetencies.map(c => {
        return { id: c.value, name: c.text }
      }),
      hierarchies: trainingMatrixFilters.selectedHierarchies,
      managerIds: trainingMatrixFilters.selectedManagers.map(m => m.value),
      matchOption: trainingMatrixFilters.hierarchyViewMode.value === 'any' ? 'MATCH_ANY' : 'MATCH_ALL',
      occupations: trainingMatrixFilters.selectedOccupations.map(o => o.text),
      people: trainingMatrixFilters.selectedPersons.map(p => {
        return { id: p.value, fullName: p.text }
      }),
      showAllCompetencies: trainingMatrixFilters.showOtherCompetencies,
      showAllReports: trainingMatrixFilters.showAllReports,
      applyHierarchyFiltersToOccupationRequirements: trainingMatrixFilters.applyHierarchyFiltersToOccupationRequirements
    })
  }, [
    trainingMatrixFilters.selectedCompetencies,
    trainingMatrixFilters.selectedHierarchies,
    trainingMatrixFilters.selectedManagers,
    trainingMatrixFilters.hierarchyViewMode,
    trainingMatrixFilters.selectedOccupations,
    trainingMatrixFilters.selectedPersons,
    trainingMatrixFilters.showOtherCompetencies,
    trainingMatrixFilters.showAllReports,
    trainingMatrixFilters.applyHierarchyFiltersToOccupationRequirements
  ])

  return currentFilters
}

export default useFormattedFilters
